import { ProgressStepCode } from '@domain/constant/progressStepCode';
import { InterviewPracticeInProgressRs } from '@domain/rs/pass/interview/practice/InterviewPracticeInProgressRs';

export class ContinueInterviewPracticeVO {
  inProgress: boolean;
  interviewPracticeSn: number;
  progressStepCode: ProgressStepCode;
  runningQuestionSn: number;

  constructor(rs: InterviewPracticeInProgressRs) {
    this.inProgress = rs.continueInterviewPractice.inProgress;
    this.interviewPracticeSn = rs.continueInterviewPractice.interviewPracticeSn;
    this.progressStepCode = rs.continueInterviewPractice.progressStepCode;
    this.runningQuestionSn = rs.continueInterviewPractice.runningQuestionSn;
  }
}
